import { Heading } from '@components/Layout/Service';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { ProjectBenefitItem } from '../../pages/services/qa-testing/constants';
import Link from 'next/link';

interface InterfaceProjectBenefitsItem {
  title?: string;
  subTitle?: string;
  projectItems: ProjectBenefitItem;
  dangerouslySetInnerHTML?: boolean;
  extraButton?: React.ReactElement | boolean;
}

const ProjectBenefits = ({
  title,
  subTitle,
  projectItems,
  dangerouslySetInnerHTML = false,
  extraButton = false,
}: InterfaceProjectBenefitsItem) => {
  const { t } = useTranslation();

  return (
    <div className="project-benefits">
      <Heading title={title || t('service.we_help')} subtitle={subTitle || t('service.whether_you_need_a_quick')} />

      {extraButton && extraButton}

      <div className="project-benefits__box">
        {projectItems.map((item, index) => (
          <div className="item" key={index}>
            <div className="icon-wrapper">
              <div className="icon">
                <div className="wrapper">
                  <Image src={item.icon || '/'} alt={t(item.title)} layout="fill" objectFit="cover" quality={100} />
                </div>
              </div>
            </div>
            <div className="text">
              <h3 dangerouslySetInnerHTML={{ __html: t(item.title) }} />

              {dangerouslySetInnerHTML ? (
                <div dangerouslySetInnerHTML={{ __html: t(item.description) }} />
              ) : (
                <p>{t(item.description)}</p>
              )}

              {item.linkService && (
                <div className="multi-link">
                  {item.linkService?.map((link, idx: number) => (
                    <Link href={link.url} key={idx}>
                      {t(link.text)}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProjectBenefits;
